document.addEventListener('teeinblue-event-after-cart-added', () => {
    Shopify.getCart((cart) => {
        document.body.classList.add('cart-sidebar-show');
        window.sharedFunctions.updateSidebarCart(cart);
        // teeinblue writes the _customization_image property to the line item
        // asynchronously, a few seconds after the item is added (preview render +
        // upload). Poll the cart and re-render the sidebar as the previews become
        // ready, so the fresh item's thumbnail isn't left missing.
        refreshSidebarWhenPreviewReady(0, null);
    });
});

// Poll for up to ~45s. teeinblue can take several seconds to generate and upload
// the preview; once _customization_image is on the line item, /cart?view=ajax_side_cart
// renders the correct thumbnail (the same render a manual page refresh performs).
function refreshSidebarWhenPreviewReady(attempt, prevPendingCount) {
    var MAX_ATTEMPTS = 60;      // 60 * 750ms = 45s
    var INTERVAL = 750;
    if (attempt > MAX_ATTEMPTS) return;

    fetch(window.routes.root + '/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
            var pendingCount = (cart.items || []).reduce(function (count, item) {
                var props = item.properties || {};
                return (props._customization_id && !props._customization_image) ? count + 1 : count;
            }, 0);

            // Re-render whenever the number of pending previews drops (a preview
            // just became ready) or once everything is ready.
            var becameReady = prevPendingCount !== null && pendingCount < prevPendingCount;
            if ((pendingCount === 0 || becameReady) &&
                window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
                window.sharedFunctions.updateSidebarCart(cart);
            }

            if (pendingCount > 0) {
                setTimeout(function () {
                    refreshSidebarWhenPreviewReady(attempt + 1, pendingCount);
                }, INTERVAL);
            }
        })
        .catch(function () {});
}

// document.addEventListener('teeinblue-event-component-injected', function() {
//   const elementToMove = document.querySelector('.size-note-wrap');
//   const insertAfterElement = document.querySelector('.tee-option--size .tee-row.tee-option-inner');
//   if (elementToMove && insertAfterElement) {        
//     insertAfterElement.after(elementToMove);
//   } 
// });

document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('div[style*="font-size: 14px"][style*="margin-top: 10px"]');
  const insertAfterElement = document.querySelector('.tee-block.tee-product-price');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.after(elementToMove);
  } 
});


var sizeNoteCloneState = {
  formObserver: null,
  docObserver: null,
  observedForm: null,
  templateHTML: '',
  clickBound: false
};

function getOriginalSizeNote() {
  return document.querySelector('.size-note-wrap:not(.size-note-wrap-clone)');
}

function getOriginalSizeButton() {
  var original = getOriginalSizeNote();
  return original ? original.querySelector('.size-open-btn') : null;
}

function getTeeArtworkForm() {
  return document.querySelector('#tee-artwork-form');
}

function getSizeAnchor() {
  return document.querySelector('#tee-artwork-form .tee-option--size .tee-option-inner');
}

function getCloneSizeNote() {
  var form = getTeeArtworkForm();
  return form ? form.querySelector('.size-note-wrap-clone') : null;
}

function hideOriginalSizeNote() {
  var original = getOriginalSizeNote();
  if (!original) return null;

  original.style.setProperty('display', 'none', 'important');
  original.setAttribute('aria-hidden', 'true');
  sizeNoteCloneState.templateHTML = original.innerHTML;

  return original;
}

function buildCloneSizeNote() {
  if (!sizeNoteCloneState.templateHTML) return null;

  var clone = document.createElement('div');
  clone.className = 'size-note-wrap size-note-wrap-clone';
  clone.innerHTML = sizeNoteCloneState.templateHTML;

  return clone;
}

function ensureSizeNoteClone() {
  hideOriginalSizeNote();

  var form = getTeeArtworkForm();
  var anchor = getSizeAnchor();
  if (!form || !anchor || !sizeNoteCloneState.templateHTML) return;

  var clone = getCloneSizeNote();

  if (!clone) {
    clone = buildCloneSizeNote();
    if (!clone) return;
  } else if (clone.innerHTML !== sizeNoteCloneState.templateHTML) {
    clone.innerHTML = sizeNoteCloneState.templateHTML;
  }

  if (anchor.nextElementSibling !== clone) {
    anchor.insertAdjacentElement('afterend', clone);
  }
}

function bindCloneClick() {
  if (sizeNoteCloneState.clickBound) return;
  sizeNoteCloneState.clickBound = true;

  document.addEventListener('click', function(event) {
    var cloneButton = event.target.closest('.size-note-wrap-clone .size-open-btn');
    if (!cloneButton) return;

    var originalButton = getOriginalSizeButton();
    if (!originalButton) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    originalButton.click();
  }, true);
}

function observeTeeArtworkForm() {
  var form = getTeeArtworkForm();
  if (!form) return;

  if (sizeNoteCloneState.formObserver && sizeNoteCloneState.observedForm === form) return;

  if (sizeNoteCloneState.formObserver) {
    sizeNoteCloneState.formObserver.disconnect();
  }

  sizeNoteCloneState.formObserver = new MutationObserver(function() {
    ensureSizeNoteClone();
  });

  sizeNoteCloneState.formObserver.observe(form, {
    childList: true,
    subtree: true
  });

  sizeNoteCloneState.observedForm = form;
}

function observeDocumentForFormReplacement() {
  if (sizeNoteCloneState.docObserver) return;

  sizeNoteCloneState.docObserver = new MutationObserver(function() {
    observeTeeArtworkForm();
    ensureSizeNoteClone();
  });

  sizeNoteCloneState.docObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

function initSizeNoteClone() {
  hideOriginalSizeNote();
  ensureSizeNoteClone();
  bindCloneClick();
  observeTeeArtworkForm();
  observeDocumentForFormReplacement();
}

document.addEventListener('teeinblue-event-component-injected', function() {
  initSizeNoteClone();
  requestAnimationFrame(initSizeNoteClone);
  setTimeout(initSizeNoteClone, 300);
});